import React from "react";
import { AiFillSetting } from "react-icons/ai";
import { FaDatabase } from "react-icons/fa";
import { MdLaptopMac } from "react-icons/md";
import { Link } from "react-router-dom";
import styled from "styled-components";

const DashboardMobilenav = ({ setMobileNav }) => {
  return (
    <div>
      <Overlay onClick={() => setMobileNav(false)}></Overlay>
      <Sidebar>
        <TopSection>
          <BorderBottom></BorderBottom>
          <Title>
            <FaDatabase className="icon" />
            Overview
          </Title>
          <BorderBottom></BorderBottom>
          <ListItem>
            <li>
              <Link to="/dashboard">Dashboard</Link>
            </li>
          </ListItem>
          <BorderBottom></BorderBottom>
          <Title>
            <MdLaptopMac className="icon" />
            Support
          </Title>
          <BorderBottom></BorderBottom>
          <ListItem>
            <li>
              <Link to="/plans">Plan</Link>
            </li>
            <li>
              <Link to="/documentation">Documentation</Link>
            </li>
            <li>
              <Link to="/ticket">Raise a Ticket</Link>
            </li>
          </ListItem>
          <BorderBottom></BorderBottom>
          <Title>
            <AiFillSetting className="icon" />
            Settings
          </Title>
          <BorderBottom></BorderBottom>
          <ListItem>
            <li>
              <Link to="/manage-account">Manage Account</Link>
            </li>
            <li>
              <Link to="/feedback">Give us feedback</Link>
            </li>
          </ListItem>
        </TopSection>
      </Sidebar>
      <Close className="closeIcon" onClick={() => setMobileNav(false)}>
        <i class="fa-solid fa-xmark"></i>
      </Close>
    </div>
  );
};

export default DashboardMobilenav;

const Overlay = styled.div`
  position: fixed;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 320%;
  background-color: #000;
  opacity: 0.7;
  z-index: 10;
  overflow: hidden;
`;

const Close = styled.div`
  position: fixed;
  right: 4.3%;
  top: 2%;
  z-index: 100;
  color: #fff !important;
  cursor: pointer;

  i {
    font-size: 30px;
  }
`;

const Sidebar = styled.div`
  position: fixed;
  top: 0%;
  left: 0%;
  height: 100%;
  width: 230px;
  background-color: #fff;
  z-index: 1000000000000;
  overflow: hidden;
  transition: all 0.2s ease-out;
  padding: 0px;
`;

const TopSection = styled.div`
  padding-top: 1rem;
`;

const BorderBottom = styled.div`
  background-color: #cfcfcf;
  width: 100%;
  height: 1px;
  margin-left: 0px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 500;
  color: #333;
  padding: 15px 15px;
  cursor: pointer;

  .icon {
    margin-right: 5px;
    font-size: 26px;
    color: #005800;
  }
`;

const ListItem = styled.ul`
  margin: 15px 0px;
  li {
    list-style: none;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 5px;
    cursor: pointer;
    padding: 0px 15px;

    a {
      color: rgb(0, 104, 74);
    }
  }
`;
